import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { InertiaLink, usePage, useForm } from '@inertiajs/inertia-react';
import SiteLayout from '@/Shared/SiteLayout';
import Icon from '@/Shared/Icon';

const Show = () => {
     const { auth, info } = usePage().props;
     const stringToHTML = function(str) {
          const domContainer = document.createElement("div");
          domContainer.innerHTML = str;
          return domContainer;
     };

     function formatEmbededVideo(str){
          const parentEmbed = stringToHTML(str);
          let oldIframe = parentEmbed.querySelectorAll("iframe");
          oldIframe = Array.from(oldIframe);
          for (const i in oldIframe) {
               let url = oldIframe[i].getAttribute("src");
               if(url){
                    url = url.replace("watch?v=", "embed/");
               }

               const newIframe = document.createElement("iframe");
               newIframe.setAttribute("width", "100%");
               newIframe.setAttribute("height", "315");
               newIframe.setAttribute("allowFullScreen", "");
               newIframe.setAttribute("frameBorder", 0);
               if (url) {
                    newIframe.setAttribute("src", url);
               }
               oldIframe[i].parentNode.replaceChild(newIframe, oldIframe[i]);
          }
          return parentEmbed.outerHTML;
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>{info.title}</title>
               </Helmet>
               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-3">
                         <div className="md:flex w-full">
                              <div className="w-full col-span-12 md:w-3/4 p-2">
                                   <h1 className="font-bold text-xl md:text-4xl uppercase bg-clip-text text-emerald-700">{info.title}</h1>
                                   {info.category && (<div className="w-fit text-sm text-gray-500 mt-2 rounded-full bg-yellow-200 text-yellow-800 px-2">{`${info.category} / ${info.subcategory?info.subcategory:''}`}</div>)}
                                   {info.cover && (<img src={info.cover} className="w-full mt-2 rounded-lg" />)}
                                   <article className="mx-auto mt-4 prose prose-slate prose-h1:text-blue-700 text-justify italic text-gray-500" dangerouslySetInnerHTML={{ __html: info.intro }}></article>
                                   <article className="mx-auto mt-4 prose prose-slate prose-h1:text-blue-700 text-justify" dangerouslySetInnerHTML={{ __html: formatEmbededVideo(info.body) }}></article>
                                   <p className="mt-4 text-sm text-emerald-700">{info.user}, {info.published}</p>
                              </div>
                              <div className="w-full col-span-12 md:w-1/4 p-2">

                              </div>
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Show.layout = page => <SiteLayout children={page} header={'View Post'} />;

export default Show;
